module.exports = "/static/assets/94b50a9a2e8d095fd731e01b5f88b3f4.png";